var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAntiques = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Table-Retro--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Table Retro Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 2.75a1.5 1.5 0 0 0 1.5 1.5h21a1.5 1.5 0 0 0 0 -3h-21A1.5 1.5 0 0 0 0 2.75Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 20.75a0.24 0.24 0 0 1 -0.18 -0.09 0.21 0.21 0 0 1 0 -0.2 18.67 18.67 0 0 1 0.79 -2A13.21 13.21 0 0 0 24 13.75a10.66 10.66 0 0 0 -1.91 -5.7 0.49 0.49 0 0 1 -0.09 -0.28V6.25a0.5 0.5 0 0 0 -0.5 -0.5h-19a0.5 0.5 0 0 0 -0.5 0.5v1.52a0.49 0.49 0 0 1 -0.09 0.28A10.66 10.66 0 0 0 0 13.75a13.21 13.21 0 0 0 1.42 4.72 19.55 19.55 0 0 1 0.79 2 0.21 0.21 0 0 1 0 0.2 0.21 0.21 0 0 1 -0.18 0.09 1 1 0 0 0 0 2h0.5A1.71 1.71 0 0 0 4 22c0.67 -1 0 -2.48 -0.78 -4.34l-0.33 -0.76a5.06 5.06 0 0 1 -0.4 -2.37l0.22 -2.95A5.09 5.09 0 0 1 3.74 9a0.49 0.49 0 0 1 0.39 -0.2 4.62 4.62 0 0 0 2 -0.5 4.82 4.82 0 0 1 2.33 -0.5 3.47 3.47 0 0 1 2 0.57 2.76 2.76 0 0 0 3.08 0 3.47 3.47 0 0 1 2 -0.57 4.82 4.82 0 0 1 2.33 0.5 4.62 4.62 0 0 0 2 0.5 0.49 0.49 0 0 1 0.39 0.2 5.05 5.05 0 0 1 1 2.64l0.22 2.95a5.22 5.22 0 0 1 -0.39 2.37l-0.34 0.76C19.93 19.53 19.29 21 20 22a1.71 1.71 0 0 0 1.54 0.74H22a1 1 0 0 0 0 -2Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAntiques);
export default ForwardRef;